import React, { FunctionComponent } from 'react';
import classes from './GeneralPageLayout.module.css';

interface Props {
  navigationBar?: React.ReactNode;
  elementCentr?: React.ReactNode;
}

export const GeneralPageLayout: FunctionComponent<Props> = ({
  navigationBar,
  elementCentr,
}) => (
  <div style={{ userSelect: 'none' }} className={classes.myDiv}>
    <div className={classes.container}>
      <div className={classes.elementBar}>{navigationBar}</div>
      <div className={classes.elementCentr}>{elementCentr}</div>
    </div>
  </div>
);

GeneralPageLayout.defaultProps = {
  navigationBar: undefined,
  elementCentr: undefined,
};
